module.exports = __webpack_public_path__ + "static/media/received_1747723315295641.e94bd420.jpg";